import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import CompanyDialog from "../dialogs/CompanyDialog";
import {Button, Popconfirm} from "antd";
import {
    DeleteOutlined,
    RightOutlined,
    CheckCircleOutlined,
    MinusCircleOutlined,
    EditFilled,
    PlusOutlined
} from "@ant-design/icons";
import PlatformDialog from "../dialogs/PlatformDialog";
import SupportDialog from "../dialogs/SupportDialog";

export default function Supports(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Mesaj',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: 'Kullanıcı',
            render: record => <span>{record?.User?.fullName}</span>,
        },
        {
            title: 'Cevap',
            dataIndex: 'answer',
            key: 'answer',
        },
        {
            title: 'Durum',

            render: record => <span>{record.isRead ? <span style={{color: 'green'}}>Okundu</span> : <span style={{color: 'red'}}>Bekliyor</span>}</span>,
        },

        {
            title: 'İşlemler',
            render: (record) => (
                <div>

                    <Button  style={{marginLeft: '4%'}} onClick={() => editDialog(record)}>
                        <EditFilled />
                    </Button>

                </div>
            )
        }

    ];

    const {api} = useApi();
    const [supports, setSupports] = useState({totalCount: 0, items:[]});
    const [dialog, setDialog] = useState({open: false, data: null});

    useEffect(() => {
        load({skip: 0, max: 10});

    }, [])

    async function load(params){
        api.get('/supportRouter/support/all', params).then(resp => {
            setSupports({totalCount: resp.totalCount, items: resp.data});
        })
    }

    function addDialog(){
        setDialog({open: true, data: null});
    }

    function editDialog(data){
        setDialog({open: true, data: data});
    }

    function deleteRow(id, record){
        api.delete("/platformRouter/platform/delete/" + id).then(resp => {
            load();
        }).finally(() => {

        })
    }

    return (
        <LayoutComponent title={"Destek Talepleri"} links={
            [
                {
                    title: 'Destek Talepleri',
                    url: '/'
                },

            ]}
        >
            <TableComponent
                columns={columns}
                data={supports}

                clickRow={(data) => editDialog(data)}
            />
            <SupportDialog
                open={dialog.open}
                data={dialog.data}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null})}
            />

        </LayoutComponent>
    )
}
